export default function FormatText(t) {
   return t.replace(/\s/g, '').replace('&', '');
}
